import styled, { createGlobalStyle } from "styled-components";

export const colors = {
    blue: "#019bbe",
    grey: "#E8E8E8",
    ligthGrey: "#F5F5F5",
    white: "#fff",
    lightWhite: "#ffffff20",
    orange: "#E16E32",
};

const GlobalStyle = createGlobalStyle`
   
  body {
    margin: 0;
    height: 100vh ;
    padding: 0;
    background: ${colors.ligthGrey};
  }
  
  //OVERRIDE
  /* Estilização do datePicker */
  .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input{
    max-height: 7px;
  }

 .MuiDataGrid-columnHeader{
    background: #019BBE1A ;
    color: #019BBE;
    font-weight: bold;
    font-size: 14px
  }
  
  .MuiButton-root {
    border-radius: 8px !important;
    text-transform: capitalize !important;
  }
  
  .MuiIconButton-root{
    &:hover{
      background: #00677e10 !important;
      border-radius: 8px !important;
    }
  }
  
  .MuiDataGrid-iconButtonContainer {
    /* visibility: visible !important; */
    /* width: 0 !important */    
  }

  .MuiDialogTitle-root{
    background: #DCECF0 !important;
    font-size: 24px;
    color: #019BBE;
  }

  .MuiDataGrid-actionsCell > .MuiButtonBase-root.MuiIconButton-root{
    color: #E16E32 !important;
    &:disabled{
      color: #E16E3250 !important;
    }    
  }

  .MuiTablePagination-actions > .MuiIconButton-root {
    color: #E16E32 !important;
    
  }

  .MuiInputAdornment-root > .MuiIconButton-root{
    color: #E16E32 !important;
  }

  .MuiAutocomplete-endAdornment > .MuiIconButton-root{
    color: #E16E32 !important;
  }

  .MuiDataGrid-root{
    border: none !important;
  }

  /* Remoção da ordem númerica da ordenação das tabelas */
  .MuiDataGrid-columnsContainer .MuiDataGrid-columnHeaderDraggableContainer > div > div.MuiDataGrid-iconButtonContainer > span > span{
    display: none;
  }
`;

export const Container = styled.div`
  > .MuiCard-root {
    margin: 0 !important;
    background: none !important;
    border-radius: 0 !important; 
    box-shadow: none !important;
    border: solid 0px #ffac0a !important;
    height: 100%;
  }
`;

export const Subtitles = styled.div`
    font-size: 20px;
    font-weight: bold;
    font-family: 'Lato', sans-serif;
    color: #5b5b5f;
    padding: 24px 0 0 0;
`;

export default GlobalStyle;
